import { BaseAnalyticsFilter } from '@repo/shared/dtos/analytics/AnalyticsFilterDto';
import { createDefaultBaseFilters } from '../../../hooks/analytics/utils';

const DEFAULT_FILTERS: BaseAnalyticsFilter = createDefaultBaseFilters();

export const filterHelpers = {
  toggleFilterId: (filters: number[], id: number): number[] =>
    filters.includes(id) ? filters.filter(f => f !== id) : [...filters, id],

  removeFilterId: (filters: number[], id: number): number[] => filters.filter(f => f !== id),

  hasActiveFilters: (filters: BaseAnalyticsFilter): boolean =>
    !!(
      filters.startDate ||
      filters.endDate ||
      filters.experienceTitle ||
      filters.experienceIds?.length ||
      filters.unitIds?.length
    ),

  createDefaultFilters: (): BaseAnalyticsFilter => ({ ...DEFAULT_FILTERS }),

  mergeFilters: (
    current: BaseAnalyticsFilter,
    updates: Partial<BaseAnalyticsFilter>,
  ): BaseAnalyticsFilter => ({ ...current, ...updates }),

  clearDateRange: (filters: BaseAnalyticsFilter): BaseAnalyticsFilter => {
    return {
      ...filters,
      startDate: undefined,
      endDate: undefined,
      granularity: 'month',
    };
  },

  clearExperiences: (filters: BaseAnalyticsFilter): BaseAnalyticsFilter => ({
    ...filters,
    experienceIds: [],
    experienceTitle: undefined,
  }),

  clearUnits: (filters: BaseAnalyticsFilter): BaseAnalyticsFilter => ({ ...filters, unitIds: [] }),
};

export const { hasActiveFilters, createDefaultFilters, mergeFilters } = filterHelpers;
